import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            来自真实读者的阅读体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-6 border border-background-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-secondary-500 text-xs"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                "{item.content}"
              </p>
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs">
                在看《{item.comic}》
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}